import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import apiRoutesV2, { baseURL } from 'src/config/api/routes';
import { prepareHeaders } from '../auth/entity/api/auth';

export type Login = {
  email: string;
  password: string;
};

export type PostResetPassword = {
  emailAddress: string;
};
export type GetResetPassword = {
  token: string;
};
export type GetResetPasswordResponse = {
  emailAddress: string;
  firstname: string;
  lastName: string;
};

export type UploadFroalaImage = {
  bookId: string;
  trajectoryId: string;
  body: { photo: string };
};

export type UploadFroalaImageResponse = {
  data: {
    image_url: string;
  };
};

export const froalaApi = createApi({
  reducerPath: 'froalaApi',
  baseQuery: fetchBaseQuery({
    baseUrl: baseURL,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    postUploadFroalaImage: builder.mutation<any, UploadFroalaImage>({
      query: ({ bookId, trajectoryId, body }) => ({
        url: apiRoutesV2.uploadImage(bookId, trajectoryId),
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { usePostUploadFroalaImageMutation } = froalaApi;
